import React from 'react';
import { useField } from 'formik';

import { AutoSuggestWithLabel } from '../molecules';

export function AutoSuggest(props) {
  const [field, meta] = useField(props);

  const error = meta.touched && meta.error ? meta.error : undefined;
  return <AutoSuggestWithLabel error={error} {...field} {...props} />;
}
